import React from 'react';
import {Header} from './Header';
import '../styles/HomePage.css'
// import {useHistory} from "react-router-dom";

export const HomePage = () => {
    /*let history = useHistory();*/
    /*const handleOnClick = () => {
        /!*const isCheckboxChecked = document.getElementById("GFG").checked;
        if(isCheckboxChecked) {
            history.push("/participate");
        } else {
            document.getElementById("sudo").innerHTML = 'Please accept this! '
        }*!/
        history.push("/participate");
    };*/
    return (
        <div className='homepage-container'>
            <Header/>
            {/*<h3 style={{color:'green', textAlign: 'center'}}>
                Proceed to Questions
            </h3>*/}
            {/*<h2 style={{color:'green'}}>
                A descriptive study to assess the compatibility with the nursing profession, among undergraduate nursing students of selected nursing college at Bhopal, MP.
            </h2>
            <hr></hr>
            <p className='about-tool'>This research study is done to assess the compatibility
                of nursing students with nursing profession. Kindly participate in this study .
                The information provided by you will be kept confidential.
                It will take your valuable 5 minutes only but your participation will help
                us to identify present scenario of nursing.
                <br></br>
                Be honest while answering so that we can evaluate better.
                <br></br><strong>Thank you !</strong>
            </p><br></br>
            <form>
                <label><i>I voluntarily agree to participate in this research study.</i></label><br></br>
                <input type="checkbox" name="check" id="GFG"
                       value="1" required/> <b>I agree</b>
            </form>*/}
            {/*<button className='participate-btn' onClick={handleOnClick}>Ok</button>*/}
            <p className='survey-closed-msg'>
                This survey has been completed!
            </p>

            <p id="sudo" style={{color:'red'}}/>

            <span id={'copyright'}>All rights reserved to the developerⒸ 2022</span>
        </div>
    );
}